import React, { Fragment, useEffect } from 'react';

//Components
import { SSNUnmasked } from '../../../../common/form/ssn/ssnUnmasked';
import { SimpleDate } from '../../../../common/form/date/simpleDateField';


//Constants
import { INPUT_TYPES } from '../../../../common/form/constants/fieldTypes';


export const RenderSearchBySSNComponents = ({ values, handleChange, handleBlur, isDocumentTypeSSN }) => {

    useEffect(() => {
        handleChange({ target: { name: 'dob', value: values.dob || values.dob_name } });
    }, []);


    return(
        <Fragment>
            <div className="grid-row grid-gap-lg margin-t-10">

                <SSNUnmasked
                    label={{
                        labelText:'selfDesignation.search.radio-label.ssn',
                        labelClasses: ['gi-ssn__label--col', 'grid-col-12' ],
                        wrapperClasses: ['grid-row','grid-col-6'],
                        isRequired: true
                    }}
                    input={{
                        id: 'ssn',
                        name: 'ssn',
                        inputClasses: ['grid-col-9 margin-t-5'],
                        displayType:'input',
                        type: INPUT_TYPES.TEXT,
                        format:'###-##=####',
                        placeholder: 'XXX-XX-XXXX',
                        value: isDocumentTypeSSN ? values.documentNumber : values.ssn,
                        readOnly: isDocumentTypeSSN,
                        maxLength: 9,
                        isInputRequired: true
                    }}
                    actions={{
                        handleFieldChange: handleChange,
                        handleFieldBlur: handleBlur
                    }}
                />
                <SimpleDate
                    label={{
                        labelText:'label.dob',
                        labelClasses: ['gi-ssn__label--col', 'grid-col-12', 'margin-t-10-ve'],
                        wrapperClasses: ['grid-row','grid-col-6'],
                        isRequired: true
                    }}
                    input={{
                        id: 'dob_ssn',
                        name: 'dob',
                        inputClasses: ['grid-col-9', 'margin-t-20-ve'],
                        type: INPUT_TYPES.TEXT,
                        format:'##/##/####',
                        placeholder:'MM/DD/YYYY',
                        value: values.dob,
                        readOnly: true,
                        maxLength: 60,
                        isInputRequired: true
                    }}
                    actions={{
                        handleFieldChange: handleChange,
                        handleFieldBlur: handleBlur
                    }}
                />
            </div>
        </Fragment>
    );
};